import { PRESENTATIONS_STATIC_PATH_V2 } from "@/api/staticPaths";

export const ITEMS = [
    {
        src: `${PRESENTATIONS_STATIC_PATH_V2}addFirstSlide1.png`,
        textKey: "presentations.createStep1",
    },
    {
        src: `${PRESENTATIONS_STATIC_PATH_V2}addFirstSlide2.png`,
        textKey: "presentations.createStep2",
    },
];
